import React from 'react';
import Configurator from './Configurator.jsx';
import Button from "./ui/button/Button.jsx";
import Image from './ui/features/Image.jsx';
import styles from './BapLabelConfigurator.styl';
import Table from "./ui/features/Table.jsx";
import jQuery from "jquery";


class BapLabelConfigurator extends Configurator {

	//Конструктор
	constructor(props) {
		super(props);
		this.db=null;

		this.state = {
			//Списки
			bucketList: [],
			specList: [],
			bapList:[],
			interList:[],
			labelList: [],                          // Подобранные аксессуары
			bapFilterList: [],                     // Спецификация оборудования

			listSearch: true,										    // Выбрана труба
			manualSearch: false,									// Выбран металлорукав
			method: 'mark',
			inputSearch: '',
			filterList: [
				{
					name: 'Ном. время работы, ч',
					value: [],
					selected: 'Все',
				},
				{
					name: 'IP',
					value: [],
					selected: 'Все',
				},
				{
					name: 'Мощность, Вт',
					value: [],
					selected: 'Все',
				},
				{
					name: 'Крепление',
					value: [],
					selected: 'Все',
				}
				]
		}

		//Кнопки
		this.doPrint = this.doPrint.bind(this);
		this.onBtnExcelClick = this.onBtnExcelClick.bind(this);
		// Обработка событий таблиц
		this.onChangeQuantity = this.onChangeQuantity.bind(this);
		this.addBasket = this.addBasket.bind(this);
		this.onDelete = this.onDelete.bind(this);

		//Служебные процедуры функции

		this.onLabelCheckChange = this.onLabelCheckChange.bind(this);
		this.onBapCheckChange = this.onBapCheckChange.bind(this);

		this.onBapChange = this.onBapChange.bind(this);
		this.onLoopClick = this.onLoopClick.bind(this);

		this.onFilterChange = this.onFilterChange.bind(this)
		this.onFilterList = this.onFilterList.bind(this)


	}

	// ++ Для Запуска

	getCustomStyles() {
		return styles;
	}

	getType() {
		return 'bap_label';
	}

	componentDidMount() {
		this.onLoadDB()
	}

	// -- Для Запуска

	onLoadDB (){
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'get'
			},
			db => {
				this.db=db
				let marker=['Выбрать']
				this.setState(prev=>{
					let filterList=[...prev.filterList]
					let startArr=['Все']
					filterList.map((i,id)=>{
						if(id===0){
							i.value=startArr.concat(db.filter['bapLabel_bap'].timeON)
						}else if(id===1){
							i.value=startArr.concat(db.filter['bapLabel_bap'].IP)
						} else if(id===2){
							i.value=startArr.concat(db.filter['bapLabel_bap'].power)
						}else if(id===3){
							i.value=startArr.concat(db.filter['bapLabel_bap'].mount)
						}
					})

				return	{bapFilterList:marker.concat(db.filter['bapLabel_bap'].article), filterList}})
			}
		);
	}



	//Отображение выбранного елемента
	onListItemCheck(item) {
		if (this.state.item && (item.article === this.state.item.article)) {
			return;
		}

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemNSI',
				article: item.article
			},
			items => {
				this.setState({item: items});
			}
		);
	}

	// -- Загрузка данных

	// Добавить элемент в корзину
	addBasket(item) {
		let elem = Object.assign({}, item)
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemNSI',
				article: item.article
			},
			items => {
				this.setState((prevState) => {
					const bucketList = [...prevState.bucketList]
					if (bucketList.some(i => {return i.article === elem.article})) {
						bucketList.map((i, id) => {
							if (i.article === elem.article) {
								i.id = id
								i.count += 1
							}
							return i
						})
					} else {
						elem.id = bucketList.length
						elem.count = 1
						bucketList.push(elem)
					}
					return {bucketList}
				}, () => {
					this.doAddToCart(this.state.bucketList)
					this.onListItemCheck(elem)
				});

			}
		);

	}

	//Удаление
	onDelete(item, type) {
			this.setState((prevState) => {
				let newBucketPipeList = prevState.bucketList.filter((el) => el.article !== item.article || el.id !== item.id)
				newBucketPipeList = newBucketPipeList.map((i, index) => {
					i.id = index
					return i
				})
				return {
					...prevState,
					bucketList: newBucketPipeList,

				}
			}, () => {
				this.doAddToCart(this.state.bucketList)
			})

		}


	// изменение количества позиции
	onChangeQuantity(item, value, type) {
			this.setState(prevState => {
				let newBasket = prevState.bucketList.map(i => {
					if (i.article === item.article) {
						i.count = +value
					}
					return i
				})
				return {
					bucketList: newBasket
				}
			}, () => {
				this.doAddToCart(this.state.bucketList)
			})
	}

// -- Работа таблиц

	// ++ Обработка событий

	onBapChange(event) {
		let value = event.target.value
		let specList=this.onFilter(value)
		this.setState({specList})
	}

	onFilter(value){
		let filterList
		let specList=[]
		let item=[]
		if(this.state.listSearch){
			filterList=this.db.list['bapLabel_bap2label'].filter(i=>{
				if(i['article_bap'].trim()===value.trim()){
					return i
				}})
			this.db.list['bapLabel_label'].map(i=>{filterList.map(item=>{
				if(i.article.trim()===item['article_label'].trim()){
					specList.push(i)
				}})})
		}else {
			let article
			if(value!=='Выбрать'){
				article=this.db.list['bapLabel_label'].find(i=>
					i.name===value).article
			}else{
				article=value
			}

			filterList=this.db.list['bapLabel_bap2label'].filter(i=>{
				if(i['article_label'].trim()===article.trim()){
					return i
				}})

			this.db.list['bapLabel_bap'].map(i=>{filterList.map(item=>{
				if(i.article.trim()===item['article_bap'].trim()){
					specList.push(i)
				}})})
		}
		return specList
	}
	onLoopClick(item){
		const {listSearch}=this.state
		this.setState({specList:this.onFilter(listSearch?item.article:item.name), item})
	}

	// ++ Чекбокс
	onLabelCheckChange() {
		let bapFilterList=['Выбрать'].concat(this.db.filter['bapLabel_label'].name)
		this.setState({
			manualSearch: true,
			listSearch: false,
			bapFilterList,
			specList: [],
			interList: [],
			method: 'mark',
			filterCable: 'Выбрать',
			inputSearch: '',
			item: []
		})

	}

	onBapCheckChange() {
		let bapFilterList=['Выбрать'].concat(this.db.filter['bapLabel_bap'].article)
		this.setState({
			specList: [],
			interList: [],
			bapFilterList,
			onLoad: true,
			manualSearch: false,
			listSearch: true,
			method: 'mark',
			filterCable: 'Выбрать',
			inputSearch: '',
			item: []
		})
	}

	// -- Чекбокс

	// ++Кнопки
	getCustomButtons() {
		let elements = [];

		elements.push(
			<Button
				x="838"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить в PDF"
				onClick={this.onBtnPrintPdfClick}
				key="printpdf"
			/>
		);

		elements.push(
			<Button
				x="533"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.printBtnIcon}
				text="Распечатать"
				onClick={this.onBtnPrintClick}
				key="print"
			/>
		);

		elements.push(
			<Button
				x="1144"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.excelBtnIcon}
				text="Сохранить в Excel"
				onClick={this.onBtnExcelClick}
				key="excel"
			/>
		);

		return elements;
	}


	// ++ Обработка печати
	doPrint(params) {
		let _params = params || {};

		_params.data = {
			speclist: JSON.stringify(this.state.bucketList)
		};

		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}



	onClickMethodLink(type) {
		if (this.state.method === type) {
			return
		}
		let item=[]
		let filterList=this.state.filterList.map(i=>{i.selected='Все'
			return i})
		this.setState({method: type,specList: [],
			interList: [], inputSearch: '', filterList,item})
	}


	onChangeInputDiam(e) {
		let value = e.target.value
		this.setState({inputSearch: value, item:[], specList:[]},()=>{this.onFilterList(this.state.filterList,this.state.inputSearch)})
	}


	onFilterChange(id, value) {
		let filterList = this.state.filterList
		this.setState(prev => {
			let newFilterList = filterList.map((i, index) => {
				if (id == index) {
						i.selected = value
				}
				return i
			})
			return {filterList: newFilterList, item:[], specList:[]}
		}, () => {
			this.onFilterList(this.state.filterList,this.state.inputSearch)
		})
	}

	onFilterList(filterList, inputSearch) {
		this.setState((prev) => {
			let items
   if(this.state.listSearch){
		 items=this.db.list['bapLabel_bap'].filter(i=>{
			 return (i.article.toLowerCase().includes(inputSearch.toLowerCase())||i.name.toLowerCase().includes(inputSearch.toLowerCase()))})

		 if(filterList[0].selected!=='Все'){
			 items=items.filter(i=>i.timeON===filterList[0].selected)
		 }
		 if(filterList[1].selected!=='Все'){
			 items=items.filter(i=>+i.IP===+filterList[1].selected)
		 }
		 if(filterList[2].selected!=='Все'){
			 items=items.filter(i=>i.power===filterList[2].selected)
		 }
		 if(filterList[3].selected!=='Все'){
			 items=items.filter(i=>i.mount===filterList[3].selected)
		 }
		 if(inputSearch.length===0 && filterList.every(i=>i.selected==='Все')){
			 items=[]
		 }
	 }else {
		  items=this.db.list['bapLabel_label'].filter(i=>{
			return (i.article.toLowerCase().includes(inputSearch.toLowerCase())||i.name.toLowerCase().includes(inputSearch.toLowerCase()))})
	    items=inputSearch.length===0?[]:items
	 }
			return {interList:items}
		})
	}

// -- Обработка печати


	render() {
		let firstLableStyle = ''
		let secondLableStyle = ''
		if (this.state.listSearch) {
			firstLableStyle = '#fff'
			secondLableStyle = '#E6EFF1'
		} else if (this.state.manualSearch) {
			firstLableStyle = '#E6EFF1'
			secondLableStyle = '#fff'
		}
		let filterStyle ={
			display: 'grid',
			gridTemplateRows: '20px 20px 20px 20px',
			gridTemplateColumns: '160px 180px',
			maxHeight: '80px',
			width: '440px',
			position: 'absolute',
			zIndex: '100',
			top: "255px",
			left: '20px',
			justifyContent: 'space-evenly',
			gap: '10px',
			alignItems: 'center'
		}

    let tableStyle=(this.state.listSearch && this.state.method==='diam')?
		{
			position: 'absolute',
				backgroundColor: '#ffffff',
			left: '20px',
			width: '440px',
			height: '220px',
			top: '100px',
			zIndex: '1'
		}:{
				position: 'absolute',
				backgroundColor: '#ffffff',
				left: '20px',
				width: '440px',
				height: '125px',
				top: '100px',
				zIndex: '1'
			}

		return (
			<div className={styles.cfg}>
				{/*Белый фон и лого*/}
				<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '10%', height: '80px' }}/>
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>
				{/*Желтый фон заголовка*/}
				<div style={{margin: '0 auto', backgroundColor: '#ffc93a', width: '100%', height: '80px'}}/>
				<div className={styles.title}>Подбор этикеток самоклеющихся</div>

				{/*Левая часть*/}
				<div style={{position: 'absolute', top: '100px', left: "20px", zIndex: '20'}}>
        	<span
						onClick={this.onBapCheckChange}
						style={{background: firstLableStyle}}
						className={styles.pipeSectionTitle + ' ' + 'activeTab'}>Подбор по светильнику</span>
					<span
						onClick={this.onLabelCheckChange}
						style={{background: secondLableStyle}}
						className={styles.flexPipeCableTitle + ' ' + 'activeTab'}>Подбор по этикетке</span>
				</div>

				<div
					style={{
						position: 'absolute',
						left: '30px',
						top: '150px',
						zIndex: '100'
					}}>
					<div className={styles.methodLink} onClick={() => this.onClickMethodLink('mark')}>
						<span style={this.state.method === 'mark' ? {color: '#fecd27', fontSize: '25px'} : {
							color: '#E6EFF1',
							fontSize: '25px'
						}}>&bull;
						</span> Выбрать из списка
					</div>
					<div className={styles.methodLink} onClick={() => this.onClickMethodLink('diam')}>
						<span style={this.state.method === 'diam' ? {color: '#fecd27', fontSize: '25px'} : {
							color: '#E6EFF1',
							fontSize: '25px'
						}}>&bull;
						</span> {!this.state.listSearch ? 'Ввести вручную':'Поиск по параметрам'}
					</div>
					{this.state.method === 'mark' ? <DropDown
						type='bap'
						x={260}
						y={5}
						key='cable'
						app={this}/> :  <div style={{
						display: 'flex',
						position: 'absolute',
						top: '22px',
						left: '260px',
					}}>{!this.state.listSearch?<input type={"text"} step={'0.01'} style={{
						width: '140px',
						height: '21px'
					}} defaultValue={this.state.inputSearch}
										onChange={e => this.onChangeInputDiam(e)}/>:<div></div>}</div>}
				</div>


				<div>
					<div style={tableStyle}/>

					{(this.state.listSearch && this.state.method==='diam') &&
						<div>
							<div style={{position:'absolute', top:'220px',left:'52px',zIndex:'200'}}>
								<span style={{ marginRight:'20px'}}>Наименование или артикул</span>
								<input type={"text"} style={{display:"inline" ,width:'205px'}}  defaultValue={this.state.inputSearch}
											 onChange={e => this.onChangeInputDiam(e)}/>
							</div>
						<div style={filterStyle}>
							{this.state.filterList.map((i, id) => {
								return (<div key={id+'filter'} style={{
									display: 'grid',
									gridTemplateColumns: '80px 100px',
									alignItems: 'center'
								}}>
										<div>{i.name}</div>
											<select defaultValue={i.selected} onChange={e => this.onFilterChange(id, e.target.value)}>
												{i.value.length > 0 ? i.value.map((item,index) => {
													return (<option key={id+index+'option'} value={item}>{item}</option>)
												}) : <option value="Все">Все</option>}
											</select>
									</div>)

							})}

						</div></div>}

					{/*Спецификация*/}
					{this.state.method==='diam'&&<Table
						title={this.state.listSearch?'СВЕТИЛЬНИКИ':'ЭТИКЕТКИ'}
						type='List'
						items={this.state.interList}
						subTitle={this.state.listSearch?'Этикетки':'Светильники'}
						styles={this.state.listSearch?{
							width: '440px',
							height: '160px',
							top: '335px',
							left: '20px',
							fontSize: '12px'
						}:{
							width: '440px',
							height: '220px',
							top: '245px',
							left: '20px',
							fontSize: '12px'}}
						onSelect={this.onListItemCheck}
						addBasket={this.onLoopClick}
						itemInfo={this.state.item}
						configType='bapLabel'
					/>}
					<Table
						title='ПОДОБРАННЫЕ РЕШЕНИЯ'
						type='listSearch'
						items={this.state.specList}
						styles={ this.state.method==='diam'?this.state.listSearch?{
							width: '440px',
							height: '190px',
							top: '560px',
							left: '20px',
							fontSize: '12px'
						}:{
							width: '440px',
							height: '220px',
							top: '532px',
							left: '20px',
							fontSize: '12px'
						}:{
							width: '440px',
							height: '505px',
							top: '245px',
							left: '20px',
							fontSize: '12px'
						}}
						onSelect={this.onListItemCheck}
						addBasket={this.addBasket}
						itemInfo={this.state.item}
						configType='listSearch'
					/>

				</div>


				{/*Середина*/}
				{/*Корзина*/}
				{
					<Table
						title='СПЕЦИФИКАЦИЯ'
						type='Bucket'
						items={this.state.bucketList}
						styles={{width: '440px', height: '595px', top: '100px', left: '480px', fontSize: '12px'}}
						onSelect={this.onListItemCheck}
						onDelete={this.onDelete}
						onChangeQuantity={this.onChangeQuantity}
						configType='listSearch'
					/>}

				{/*Правая часть*/}
				{/* Артикул и имя */}
				<div className={styles.itemInfoBG}/>
				{this.state.item && this.state.item[0] ? (
					<a href={`https://www.iek.ru/products/catalog/?page=detail&article=${this.state.item[0].art}`}
						 target="_blank">
						<div className={styles.itemInfo}>
							<div className={styles.itemInfo_Article}>{this.state.item[0].art}</div>
							<div>{this.state.item[0].name}</div>
						</div>
					</a>
				) : (
					<div className={styles.itemInfoNoArticle}/>
				)}

				{/* Фото */}
				<Image
					className={styles.itemImg}
					url={this.state.item && this.state.item[0] && this.state.item[0].ImgPng[0].file_ref.uri ? this.state.item[0].ImgPng[0].file_ref.uri : null}
				/>


				{/* Описание */}
				<div style={{
					position: 'absolute',
					top: '452px',
					left: '940px',
					backgroundColor: '#fff',
					width: '434px',
					height: '292px'
				}}/>
				{this.state.item && this.state.item[0] && this.state.item[0].Description[0].desc_ru ? (
					<div className={styles.description}>
						{this.state.item[0].Description[0].desc_ru}
					</div>
				) : (
					<div className={styles.descriptionEmpty}>
					</div>
				)}


				{/*Кнопки*/}
				{this.getCustomButtons ? this.getCustomButtons() : null}

				{/*Нижняя плашка*/}
				{/* На основной сайт IEK */}
				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top: '820px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffc93a',
					width: '50%',
					height: '20px',
					top: '820px',
					left: '700px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '823px',
					left: '415px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}}
				href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>
			</div>
		)
	}
}

export default BapLabelConfigurator;


class DropDown extends React.Component {

	render() {

		let typeCap = this.props.app.capitalizeFirstLetter(this.props.type)

		return <div>
			<span className={styles.selectLabel}
						style={{top: this.props.y + 'px', left: this.props.x + 'px'}}>{this.props.header}</span>
			<select
				className={styles.selectBase}
				style={{top: this.props.y + 17 + 'px', left: this.props.x + 'px'}}
				onChange={this.props.app['on' + typeCap + 'Change']}
				value={this.props.app.state['filter' + typeCap]}
			> {this.props.app.state[this.props.type + 'FilterList'].length > 0
				? this.props.app.state[this.props.type + 'FilterList'].map((option, index) => {
					return (
						<option value={option} key={index + option}>{option} </option>)
				})
				: <option value="Выбрать">Выбрать</option>
			}
			</select>
		</div>
	}

}





// WEBPACK FOOTER //
// ./src/react/BapLabelConfigurator.jsx